window.addEventListener("scroll", function () {
  const header = document.querySelector(".wt-header");
  if (!header) return;
  
  const headerEl = document.querySelector("header");
  headerEl.classList.add("sticky-show");
  if (window.scrollY > 10) {
    header.classList.add("wt-header-scrolled");
  } else {
    header.classList.remove("wt-header-scrolled");
  }
});

this.scrollHandler = () => {};
document.addEventListener("DOMContentLoaded", () => {
  const triggerSection = document.querySelector(".wt-product__wrapper");
  const stickyHeader = document.getElementById("pdp-sticky-header");
  const header = document.getElementById("header");
  if (!triggerSection || !stickyHeader) return;
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {
        stickyHeader.classList.remove("hidden");
        stickyHeader.classList.add("visible");
        header.style.display = 'none';
      } else {
        header.style.display = 'block';
        stickyHeader.classList.remove("visible");
        stickyHeader.classList.add("hidden");
      }
    },
    {
      root: null,
      threshold: 0.2,
    }
  );

  observer.observe(triggerSection);
});

const sections = document.querySelectorAll("main > section");
const paragraphs = document.querySelectorAll("p.section-list-item");
document.querySelectorAll("p.section-list-item").forEach((paragraph) => {
  paragraph.addEventListener("click", () => {
    const targetId = Number(paragraph.id) - 1; 
    const targetSection = sections[targetId];
    if (targetSection) {
      const topOffset = targetSection.offsetTop-82;
      window.scrollTo({
        top: topOffset,
        behavior: "smooth"
      });
    }
  });
});

/*
function highlightActiveSection(entryId) {
  paragraphs.forEach(p => {
    console.log(Number(p.id) === entryId)
    if (Number(p.id) === entryId) {
      p.classList.add('active');
    } else {
      p.classList.remove('active');
    }
  });
}


const observer = new IntersectionObserver((entries) => {
  const visibleSections = entries
    .filter(entry => entry.isIntersecting)
    .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top); 

  if (visibleSections.length > 0) {
    const topSection = visibleSections[0].target;
    const index = Array.from(sections).indexOf(topSection);
    highlightActiveSection(index);
  }
}, {
  threshold: 0.3, 
});

sections.forEach(section => observer.observe(section)); */

function getMostVisibleSectionIndex() {
  let bestIndex = 0;
  let maxVisibleHeight = 0;

  sections.forEach((section, index) => {
    const rect = section.getBoundingClientRect();
    const visibleTop = Math.max(rect.top, 0);
    const visibleBottom = Math.min(rect.bottom, window.innerHeight);
    const visibleHeight = visibleBottom - visibleTop;

    if (visibleHeight > maxVisibleHeight && visibleHeight > section.offsetHeight / 2) {
      maxVisibleHeight = visibleHeight;
      bestIndex = index;
    }
  });

  return bestIndex;
}

function updateActiveParagraph() {
  const activeIndex = getMostVisibleSectionIndex() + 1;

  paragraphs.forEach((p) => {
    if (Number(p.id) === activeIndex) {
      p.classList.add('active');
    } else {
      p.classList.remove('active');
    }
  });
}

window.addEventListener('scroll', () => {
  window.requestAnimationFrame(updateActiveParagraph);
});

document.querySelectorAll(".featured-navigation-link").forEach((link) => {
  link.addEventListener("click", () => {
    console.log(link.textContent);
  });
});